/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-nested-ternary */
/** @jsx jsx */
/* eslint-disable eqeqeq */
import moment from 'moment';
import { css, jsx } from '@emotion/core';
import FlexBox from 'components/atoms/FlexBox';
import Accordion from 'components/molecules/Accordion';
import ChangeLogModal from 'components/molecules/ChangeLogModal';
import Modal from 'components/molecules/Modal';
import DataTable from 'components/organismos/DataTable/DataTable';
import {utilityColor } from 'components/styles'; 
import React from 'react';
import { useHistory } from 'react-router-dom';
import ApplyingStampDomain from '../domain/applyingStampDomain';
import { useApplyingTransferForm } from './hook';
import { SubActionButton } from "components/atoms/Button";
import { ActionButton } from 'components/atoms/Button/SubActionButton';
import FlexBoxItem from 'components/atoms/FlexBoxItem';
import IconLabelButton from 'components/molecules/IconLabelButton';
import TextTooltip from 'components/molecules/TextTooltip';
const StampAccordion: React.FC<{
  list: ApplyingStampDomain[];
  setApplyingStampList: any;
  fetchApprovedList: any;
  fetchRejectedList: any;
}> = ({
  list, setApplyingStampList, fetchApprovedList, fetchRejectedList,
}) => {
  const {
    changeLogData,
    setChangeLogData,
    changeLogModalOpen,
    setChangeLogModalOpen,
    setSelectChangelog,
    fetchChangeLog,
  } = useApplyingTransferForm(list);
  const history = useHistory();
  const columns = React.useMemo(
    () => [
      {
        Header: () => '',
        id: 'edit',
        accessor: 'edit',
        Cell: (cell: {
          row: { isExpanded: boolean; original: any; index: number };
          data: any;
        }) => (
          <FlexBox customStyle={css({ justifyContent: 'center' })}>
              <FlexBoxItem width='36px'>
                <SubActionButton
              text="編集"
              onClick={() => {
                sessionStorage.setItem('attendStampList.targetDateFrom', moment(cell.row.original.stampListStartTime).format('YYYY-MM-DD'));
                sessionStorage.setItem('attendStampList.targetDateTo', moment(cell.row.original.stampListEndTime).format('YYYY-MM-DD'));
                sessionStorage.setItem('attendStampList.orgCode', String(cell.row.original.orgCode));
                sessionStorage.setItem('attendStampList.staffCode', String(cell.row.original.staffCode));

                sessionStorage.setItem('application.orgCode', String(cell.row.original.orgCode));
                sessionStorage.setItem('application.staffCode', String(cell.row.original.staffCode));

                sessionStorage.setItem('application.dispStaffName', `${cell.row.original.staffCode} ${cell.row.original.staffName}`);
                sessionStorage.setItem('application.targetDate', moment(cell.row.original.targetDate).format('YYYY-MM-DD'));

                sessionStorage.setItem('application.achievementId', cell.row.original.achievementId || '');
                sessionStorage.setItem('application.stampVersion', cell.row.original.version || '');
                sessionStorage.setItem('application.modifierApplicationId', cell.row.original.modifierApplicationId || '');

                sessionStorage.setItem('application.returnDestination', window.location.pathname);
                sessionStorage.setItem('attendStampList.returnDestination', window.location.pathname);

                history.push('attendApplicationList/attendStampModificationApplication');
              }}
              action={ActionButton.EDIT}
            />
              </FlexBoxItem>
           
          </FlexBox>
        ),
        disableSortBy: true,
      },
      {
        Header: '申請者',
        accessor: 'applicant',
        Cell: (cell: { row: { isExpanded: boolean; original: any } }) => (
          <div style={{ textAlign: "left" }}>
            {cell.row.original.staffCode}<br></br>{cell.row.original.staffName}
          </div>
        )
      },
      {
        Header: '申請日時',
        accessor: 'applicationDate',
      },
      {
        Header: '対象者',
        accessor: 'targetPerson',
        Cell: (cell: { row: { isExpanded: boolean; original: any } }) => (
          <div style={{ textAlign: "left" }}>
            {cell.row.original.staffCode}<br></br>{cell.row.original.staffName}
          </div>
        )
      },
      {
        Header: '対象日付',
        id: '',
        accessor: 'targetDate',
        Cell: (cell: {
          row: { isExpanded: boolean; original: any; index: number };
          data: any;
        }) => (
          <div style={{ textAlign: 'center' }}>
            <div>{cell.row.original.targetDate}</div>
                <IconLabelButton
                  onClick={() => {
                    fetchChangeLog(cell.row.original.modifierApplicationId);
                    setChangeLogModalOpen(true);
                    setSelectChangelog('0');
                  }}
                  text="更新履歴"
                  textAlign="center"
                  isIcon={false}
                />
          </div>
        ),
      },
      {
        Header: '申請\n種別',
        accessor: 'modifiyStatusName',
      },
      {
        Header: '出勤組織',
        accessor: 'stampOrgName',
      },
      {
        Header: '開始\n時間', // starttime
        accessor: 'stampListStartTime', // .startTime
        Cell: (cell: { row :{ isExpanded: boolean, original: any }}) => (
          <div style={{ textAlign: 'center' }}>
            {cell.row.original.stampListStartTime}
          </div>
        ),
      },
      {
        Header: '終了\n時間', // endtime
        accessor: 'stampListEndTime', // .endTime
        Cell: (cell: { row :{ isExpanded: boolean, original: any }}) => (
          <div style={{ textAlign: 'center'}}>
            {cell.row.original.stampListEndTime && cell.row.original.stampListEndTime}
          </div>
        ),
      },
      // {
      //   Header: '業務内容', // business content
      //   accessor: 'stampListBusinessName', // .businessName
      //   Cell: (cell: { row :{ isExpanded: boolean, original: any }}) => (
      //     <div style={{ textAlign: 'left', whiteSpace: 'pre' }}>
      //       {cell.row.original.stampListBusinessName}
      //     </div>
      //   ),
      // },
      {
        Header: '申請理由',
        accessor: 'applicationReason',
        Cell: (cell: {row: { isExpanded: boolean; original: any }})=>(
          <TextTooltip text={cell.row.original?.applicationReason} textDis={(
            <div className="ellipsis headline-cell-width-100"
              style={{
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                width: '100px'
              }}>
                {cell.row.original?.applicationReason}
            </div>
          )} />  
        )
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [list, fetchChangeLog, setChangeLogModalOpen, setSelectChangelog],
  );

  return (
    <div className="margin-accordian"
      css={css`
      table th:nth-of-type(1) {
        width: 40px;
      }
      table th:nth-of-type(2) {
        width: 120px;
      }
      // table td:nth-of-type(2) {
      //   white-space: pre-line;
      // }
      table th:nth-of-type(3) {
        width: 80px;
      }
      table tbody tr td:nth-of-type(3) {
        text-align: center;
      }
      table th:nth-of-type(4) {
        width: 120px;
      }
      table td:nth-of-type(4) {
        white-space: pre-line;
      }
      table th:nth-of-type(5) {
        width: 80px;
      }
      table th:nth-of-type(6) {
        width: 55px;
        white-space: pre;
      }
      table th:nth-of-type(6) span{
          display:block;
          margin: auto;
      }
      table th:nth-of-type(6) span svg {
        margin-left: 0!important;
      }
      table th:nth-of-type(7) {
        width: 140px;
      
      }
      table th:nth-of-type(8) {
        width: 80px;
        white-space: pre;
      }
      table th:nth-of-type(9) {
        width: 80px;
        white-space: pre;
      }
      table th:nth-of-type(10) {
        width: 80px;
      }
      table th:nth-of-type(10) {
        width: 100px;
      }
      
      `}
    >
      <Accordion
        text={`打刻修正申請 (${list.length}件）`}
        callBack={() => {}}
        css={css({ backgroundColor: utilityColor.white })}
      >
        <div style={{ overflowX: 'auto', whiteSpace: 'nowrap', padding:'0 10px 10px'}}>
          <DataTable classNameParrant="border-left-right border-bottom" columns={columns} className="table-no-border-left-right" data={list} isGlobalFilter={true} minWidth="100%" sortBy={[{ id: 'applicationDate', desc: true }]} />
        </div>
      </Accordion>
      {/* Change log  */}
      <div css={css(">div>div{ width: 1000px }")}>
        <Modal
          closeHandler={() => {
            setChangeLogModalOpen(false);
            setChangeLogData([]); 
          }}
          open={changeLogModalOpen}
          title="更新履歴"
          submitText="閉じる"
          onSubmit={() => {
            setChangeLogModalOpen(false);
            setChangeLogData([]);
          }}
          closeText=""
        >
          <ChangeLogModal changeLogData={changeLogData} isStamp={true}/>
        </Modal>
      </div>
      {/* ./Change log  */}
    </div>
  );
};

export default StampAccordion;
